app.controller("ShareController",
	["$scope", "FacebookService", function($scope, FacebookService) {
		FacebookService.Initialize();

		$scope.Share = function() {
			FacebookService.Share(window.location.href);
		};

		$scope.shareTwitter = function() {
			var twtTitle = document.title;
			var twtUrl = location.href;
			var maxLength = 140 - (twtUrl.length + 1);
			var width  = 575;
    		var height = 400;
    		var left   = ($(window).width()  - width)  / 2;
    		var top    = ($(window).height() - height) / 2;
    		var opts   = 'status=1' +
	             ',width='  + width  +
	             ',height=' + height +
	             ',top='    + top    +
	             ',left='   + left;

			if (twtTitle.length > maxLength) {
			    twtTitle = twtTitle.substr(0, (maxLength - 3)) + '...';
			}

			var twtLink = 'https://twitter.com/home?status=' + encodeURIComponent(twtTitle + ' ' + twtUrl);
			
			window.open(twtLink, 'twitter', opts);
			return false;
		};
	}]
);